import { inject } from '@angular/core';
import { Router, Routes, CanActivateFn } from '@angular/router';
import { AuthGuard } from '@auth/auth.guard';
import { SilentRefreshComponent } from '@app/features/silent-refresh/silent-refresh.component';
import { EnvironmentService } from '@core/services/environment.service';
import { NotFoundRedirectComponent } from '@app/features/status-pages/not-found-redirect.component';

export const ROUTE_PATHS = {
	DASHBOARD: 'dashboard',
	USER_PROFILE: 'user-profile',
	API_CREDENTIALS: 'api-credentials',
	TESTBOARD: 'testboard',
	REGISTRATION_FORM: 'registration-form',
	REGISTRATION_FORM_FALLBACK: 'registration',
	STATUS_PAGES: 'status-pages',
	FORCE_500: 'force-500',
	SILENT_REFRESH: 'silent-refresh',
} as const;

const nonProductionOnlyGuard: CanActivateFn = () => {
	const environmentService = inject(EnvironmentService);
	const router = inject(Router);

	return !environmentService.isProduction || router.createUrlTree([`/${ROUTE_PATHS.DASHBOARD}`]);
};

export const APP_ROUTES: Routes = [
	{
		path: '',
		redirectTo: ROUTE_PATHS.DASHBOARD,
		pathMatch: 'full',
	},
	{
		path: ROUTE_PATHS.FORCE_500,
		loadChildren: () => import('./features/force-500/force-500.routes').then((m) => m.FORCE_500_ROUTES),
		canActivate: [AuthGuard, nonProductionOnlyGuard],
	},
	{
		path: ROUTE_PATHS.SILENT_REFRESH,
		component: SilentRefreshComponent,
	},
	{
		path: ROUTE_PATHS.DASHBOARD,
		loadChildren: () => import('./features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
		canActivate: [AuthGuard],
	},
	{
		path: ROUTE_PATHS.API_CREDENTIALS,
		loadChildren: () =>
			import('./features/api-credentials/api-credentials.routes').then((m) => m.API_CREDENTIALS_ROUTES),
		canActivate: [AuthGuard],
	},
	{
		path: ROUTE_PATHS.USER_PROFILE,
		loadChildren: () => import('./features/user-profile/user-profile.routes').then((m) => m.USER_PROFILE_ROUTES),
		canActivate: [AuthGuard],
	},
	{
		path: ROUTE_PATHS.REGISTRATION_FORM,
		loadChildren: () =>
			import('./features/registration-form/registration-form.routes').then((m) => m.REGISTRATION_FORM_ROUTES),
		canActivate: [AuthGuard],
	},
	{
		path: ROUTE_PATHS.REGISTRATION_FORM_FALLBACK,
		loadChildren: () =>
			import('./features/registration-form/registration-form.routes').then((m) => m.REGISTRATION_FORM_ROUTES),
		canActivate: [AuthGuard],
	},
	{
		path: ROUTE_PATHS.TESTBOARD,
		loadChildren: () => import('./features/testboard/testboard.routes').then((m) => m.TESTBOARD_ROUTES),
		canActivate: [AuthGuard, nonProductionOnlyGuard],
	},
	{
		path: '',
		loadChildren: () => import('./features/status-pages/status-pages.routes').then((m) => m.STATUS_PAGES_ROUTES),
	},
	{
		path: '**',
		component: NotFoundRedirectComponent,
	},
];
